import Resource from '@/api/resources/Resource'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class AuditedActionService extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put('/auditedActions', filterModel, { params })
        return response.data
    }

    async findById(auditedActionId) {
        const response = await this.axios.get(`/auditedActions/${auditedActionId}`)
        return response.data
    }

    async exportTo(sectionLabel, filterModel, sortModel, columns, selectedIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        return this.axios.put(
            '/auditedActions/reportAuditedActionsGrid',
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }

    async findAllActionTypesSorted() {
        const response = await this.axios.get('/auditedActions/auditedActionTypes')
        return response.data.sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()))
    }

    async findAllEntityTypes() {
        const response = await this.axios.get('/auditedActions/auditedActionEntityTypes')
        return response.data
    }

    async findAllEntityTypesSorted() {
        const response = await this.axios.get('/auditedActions/auditedActionEntityTypes')
        return response.data.sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()))
    }
}

export default new AuditedActionService()

export const AUDITED_ACTION_TYPES = {
    QUERY: { id: 1, iconClass: 'fa-eye' },
    UPDATE: { id: 2, iconClass: 'fa-edit' },
    CREATION: { id: 3, iconClass: 'fa-plus-circle' },
    DELETION: { id: 4, iconClass: 'fa-minus-circle' },
    REPORT_GENERATION: { id: 5, iconClass: 'fa-file-plus' },
    LABEL_PRINTING: { id: 6, iconClass: 'fa-print' },
    EXPORT: { id: 7, iconClass: 'fa-file-download' },
    LOG_IN: { id: 8, iconClass: 'fa-sign-in' },
    LOG_OUT: { id: 9, iconClass: 'fa-sign-out' },
    GENERATE_TOKEN_IN_NAME_OF_ANOTHER_USER: { id: 10, iconClass: 'fa-key' }
}

export function getIconFromActionType(actionTypeId) {
    return Object.values(AUDITED_ACTION_TYPES)
        .find((actionType) => actionType.id === actionTypeId).iconClass || ''
}

export const AUDITED_ENTITY_TYPES = {
    COMPLEMENTARY: {
        'id': 'com.vitro.anapath.dao.model.Complementary'
    },
    INCIDENT: {
        'id': 'com.vitro.anapath.dao.model.Incident'
    },
    PORTION: {
        'id': 'com.vitro.anapath.dao.model.Portion'
    },
    PATIENT: {
        'id': 'com.vitro.anapath.dao.model.Patient'
    },
    SUBPORTION: {
        'id': 'com.vitro.anapath.dao.model.Subportion'
    },
    CASE: {
        'id': 'com.vitro.anapath.dao.model.Case'
    },
    REQUEST: {
        'id': 'com.vitro.anapath.dao.model.Request'
    },
    SAMPLE: {
        'id': 'com.vitro.anapath.dao.model.Sample'
    },
    USER: {
        'id': 'com.vitro.anapath.dao.model.Userapp'
    },
    SHIPMENTS: {
        'id': 'com.vitro.anapath.shipments.shipment.domain.Shipment'
    }
}
